import Axios from 'src/services/axios';
import configServiceFactoryFactory, { ConfigurationService, fetchFingerPrint } from './service';

const configServiceFactory = configServiceFactoryFactory(Axios);
export const fetchFingerprintFactory = fetchFingerPrint(Axios);

export default configServiceFactory;
export type { ConfigurationService };
